<script>
import veloGroups from '../models/veloGroups';
import veloZipCodes from '../models/veloZipCodes';
import Leaflet from 'leaflet';

export default {
  props: {},

  data() {
    return {
      container: null,
      form: {},
      calendar: {
        activeTab: 0,
        dateOptions: {year: 'numeric', month: 'long', day: 'numeric'},
        latestDayOfReturn: new Date(2023,3,8),
        days: [],
        disabledDates: []
      },
      groups: veloGroups,
      validZipCodes: veloZipCodes,
      merchants: [],
      activeStep: 1,
      validation: {
        step1: {
          isValidated: false,
          isValid: false
        },
        step2: {
          isValidated: false,
          isValid: false
        },
        step3: {
          isValidated: false,
          isValid: false
        },
        step4: {
          isValidated: false,
          isValid: false
        },
      },
      response: {
        id: ''
      },
      isSubmitted: false,
      map: null
    }
  },

  mounted() {
    this.container = document.querySelector('.js-vue-velo-service');
  },

  created() {
    this.getMerchants();
    this.reset();
  },

  watch: {
    'activeStep': function (val) {
      this.container.scrollIntoView();

      if (val === 1) {
        this.loadMap();
      }
    },

    'form.merchant': function (val) {
      // reset validation of this step if value has changed
      this.validation.step1.isValidated = false;
    },

    'form.customer.pickup': {
      handler(val, oldVal) {
        if (!this.form.customer.hasDifferentInvoice) {
          this.form.customer.invoice = {...this.form.customer.pickup};
        }
      },
      deep: true
    },

    'form.customer.hasDifferentInvoice': function (val) {
      if (val) {
        this.form.customer.invoice.salutation = '';
        this.form.customer.invoice.preName = '';
        this.form.customer.invoice.lastName = '';
        this.form.customer.invoice.street = '';
        this.form.customer.invoice.streetNumber = '';
        this.form.customer.invoice.zip = '';
        this.form.customer.invoice.city = '';
      } else {
        this.form.customer.invoice = {...this.form.customer.pickup};
      }
    },

    'merchants': function(val) {
      this.loadMap();
    },

    'calendar.days': {
      handler(val, oldVal) {
        if (this.calendar.days.length >= 1) {
          this.form.customer.appointments.pickup.date = this.calendar.days[0];
        } else {
          this.form.customer.appointments.pickup.date = null;
        }

        if (this.calendar.days.length >= 2) {
          this.form.customer.appointments.return.date = this.calendar.days[1];
        } else {
          this.form.customer.appointments.return.date = null;
        }
      },
      deep: true
    },

    'form.customer.appointments.pickup.date': function() {
      if (this.calendar.days.length >= 2) {
        this.calendar.days.splice(-1, 1);
      }
    },

    initialDisabledDates: function () {
      this.calendar.disabledDates = this.initialDisabledDates;
    },

    'calendar.activeTab': function (val, oldVal) {
      if (this.calendar.activeTab === 0 || this.form.customer.appointments.pickup.date === null) {
        this.calendar.disabledDates = this.initialDisabledDates;
      } else {
        const start = this.form.customer.appointments.pickup.date.date;

        const rangeStart = new Date(
            start.getFullYear(),
            start.getMonth(),
            start.getDate() + 7
        );

        const rangeEnd = new Date(
            rangeStart.getFullYear(),
            rangeStart.getMonth(),
            rangeStart.getDate() + 21
        );

        this.calendar.disabledDates = [
          {
            start: null,
            end: rangeStart,
          },
          {
            start: rangeEnd,
            end: null,
          },
        ].concat(this.initialDisabledDates);

        this.$nextTick(function () {
          // move to next active month
          this.$refs.calendar.move(rangeStart);
        });
      }
    },
  },

  methods: {
    getMerchants() {
      let _this = this;

      fetch("/ajax/velo-service/merchants/get", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.success) {
              _this.merchants = response.data
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },

    loadMap() {
      let _this = this;
      this.$nextTick(function () {
        _this.map = Leaflet.map('map').setView([46.95, 7.44], 13);
        Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 10,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(_this.map);

        _this.merchants.forEach(merchant => {
          Leaflet
              .marker(merchant.coords, {
                alt: merchant.name,
                name: merchant.name,
                street: merchant.street,
                zip: merchant.zip,
                city: merchant.city,
                brands: merchant.brands
              })
              .addTo(_this.map)
              .bindPopup(`<strong>${merchant.name}</strong><br>${merchant.street}<br>${merchant.zip} ${merchant.city}`)
              .on('click', (e) => {
                console.log(e);
                _this.form.merchant = e.sourceTarget.options;
              });
        })
      });
    },

    validate() {
      switch (this.activeStep) {
        case 1:
          this.validation.step1.isValidated = true;
          this.validation.step1.isValid = this.form.merchant !== null;

          if (this.validation.step1.isValid) {
            this.activeStep++;
          }
          break;

        case 2:
          this.validation.step2.isValidated = true;
          this.validation.step2.isValid = this.container.checkValidity();

          if (this.validation.step2.isValid) {
            this.activeStep++;
          }
          break;

        case 3:
          this.validation.step3.isValidated = true;
          // ignore zip codes at the moment
          //this.validation.step3.isValid = this.validZipCodes.includes(parseInt(this.form.customer.pickup.zip)) && this.container.checkValidity();
          this.validation.step3.isValid = this.container.checkValidity();

          if (this.validation.step3.isValid) {
            this.activeStep++;
          }
          break;
      }

      if (!this.container.checkValidity()) {
        this.container.reportValidity();
      }
    },

    addBike() {
      this.form.bikes.push({
        name: '',
        brand: ''
      })

      // reset select
      event.target.value = '';
    },

    removeBike(bike) {
      this.form.bikes.splice(this.form.bikes.indexOf(bike), 1);
    },

    getBrandsByGroup(index, value) {
      let data = this.groups[index].bikes.filter(el => {
        return el.name === value
      })

      if (data.length > 0) {
        return data[0].brands;
      }

      return [];
    },

    getImageByBike(index, value) {
      let data = this.groups[index].bikes.filter(el => {
        return el.name === value
      })

      if (data.length > 0) {
        return data[0].brands;
      }

      return [];
    },

    onDayClick(day) {
      const idx = this.calendar.days.findIndex(d => d.id === day.id);

      if (idx >= 0) {
        this.calendar.days.splice(idx, 1);
      } else {
        if (day.isDisabled !== false) {
          return
        }

        this.$set(this.calendar.days, this.calendar.activeTab, {
          id: day.id,
          date: day.date
        });

        if (this.calendar.activeTab === 0) {
          this.calendar.activeTab = 1;
        }
      }
    },

    minDate() {
      return new Date(new Date().setDate(new Date().getDate() + 1));
    },

    maxDate() {
      const date = new Date(
          this.calendar.latestDayOfReturn.getFullYear(),
          this.calendar.latestDayOfReturn.getMonth(),
          this.calendar.latestDayOfReturn.getDate()
      );

      if (this.calendar.activeTab === 0) {
        // one week + length of disabled dates without the weekday entry + amount of disabled weekdays
        date.setDate(this.calendar.latestDayOfReturn.getDate() - 8);
      }

      return date;
    },

    reset() {
      // reset form values
      this.activeStep = 1;
      this.form = {
        bikes: [],
        merchant: null,
        customer: {
          pickup: {
            salutation: '',
            preName: '',
            lastName: '',
            street: '',
            streetNumber: '',
            zip: '',
            city: '',
          },
          invoice: {
            salutation: '',
            preName: '',
            lastName: '',
            street: '',
            streetNumber: '',
            zip: '',
            city: '',
          },
          appointments: {
            pickup: {
              date: null,
              daytime: 'Vormittags'
            },
            return: {
              date: null,
              daytime: 'Vormittags'
            }
          },
          birthdate: '',
          mobile: '',
          eMail: '',
          membershipId: '',
          message: '',
          hasDifferentInvoice: false,
          termsAccepted: false,
        }
      };

      // reset calendar values
      this.calendar.activeTab = 0;
      this.calendar.days = [];
      this.calendar.disabledDates = this.initialDisabledDates;
    },

    submit() {
      let _this = this;

      fetch("/ajax/velo-service/add", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(_this.form)
      })
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.success) {
              _this.isSubmitted = true;
              _this.response.id = response.id;
              _this.container.scrollIntoView();
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    }
  },

  computed: {
    amountOfBikes: function () {
      return this.form.bikes.length;
    },

    totalPrice: function () {
      return 75 * this.amountOfBikes;
    },

    pickupDate: function () {
      if (this.form.customer.appointments.pickup.date !== null) {
        return this.form.customer.appointments.pickup.date.date.toLocaleDateString("de-DE", this.calendar.dateOptions);
      }

      return 'Bitte wählen';
    },

    returnDate: function () {
      if (this.form.customer.appointments.return.date !== null) {
        return this.form.customer.appointments.return.date.date.toLocaleDateString("de-DE", this.calendar.dateOptions);
      }

      return 'Bitte wählen';
    },

    dates() {
      return this.calendar.days.map(day => day.date);
    },

    initialDisabledDates() {
      return [{weekdays: [1, 2]}];
    },

    attributes() {
      return this.dates.map((date, index) => ({
        // this part configures the custom css of the selected days
        highlight: {
          class: "date-highlight " + (index === 0 ? "is-start-date" : "is-end-date"),
          contentClass: 'date-text'
        },
        dates: date,
      }));
    },
  },

  components: {}
};
</script>
